import type { HeroCarouselSlide } from "@/components/ui/custom/hero-carousel/HeroCarousel";
import Image from "next/image";

/**
 * Default carousel slides - used as fallback when API fails or returns empty
 */
export const DEFAULT_CAROUSEL_SLIDES: HeroCarouselSlide[] = [
  {
    videoUrl: "/video/carousel/immutable-prize-wheel.webm",
    description:
      "Spin the $5,000 Prize Wheel.\nPlay Games. Refer Friends. Spin Again.",
    logoUrl: "/images/Immutable Horizontal Lockup.svg",
    ctaText: (
      <div className="flex items-center justify-center gap-2 text-center leading-tight">
        <Image
          src="/icons/icon-onDark.svg"
          alt="Immutable icon"
          width={25}
          height={25}
        />
        <div>Spin the Wheel</div>
      </div>
    ),
    route: "/referral",
    thumbnailUrl: "/images/spinning-wheel-thumbnail.svg",
  },
];
